import ModalThankYouGuest from './ModalThankYouGuest';

export default ModalThankYouGuest;
